class RoleMembers {
  role = '';
  
  names = [];

  constructor(data) {
    if (data != null) {
      this.role = data.role;
      this.names = data.names;
    }
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new RoleMembers(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }
    return list.map((data) => RoleMembers.fromObject(data));
  }
}

export default RoleMembers;
